var ispTranslations = {
    'addToCart' : { //Q
        'eng' : 'Add to cart',
        'ita' : 'Aggiungi al carrello',
        'fra' : 'Ajouter au panier',
        'deu' : 'In den Warenkorb',
        'esp' : ''
    },
    'view' : { //P
        'eng' : 'View',
        'ita' : 'Vista',
        'fra' : 'Voire',
        'deu' : 'Zeigen',
        'esp' : ''
    },
    'viewDetails' : { //Q
        'eng' : 'Show Details',
        'ita' : 'Vedi Dettagli',
        'fra' : 'voir les détails',
        'deu' : 'details anzeigen',
        'esp' : ''
    },
    'dream' : { //P
        'eng' : 'Dream',
        'ita' : 'LISTA DEI DESIDERI',
        'fra' : 'Rever',
        'deu' : 'Träumen',
        'esp' : ''
    },

    'search': { //P - Scrivere su placeholder...
        'eng' : 'Search',
        'ita' : 'Ricerca',
        'fra' : 'Chercher',
        'deu' : 'Suche',
        'esp' : 'Busca'
    },
    'size' : { //P
        'eng' : 'Size',
        'ita' : 'Taglia',
        'fra' : 'Votre Taille',
        'deu' : 'Größe',
        'esp' : 'Talla'
    },
    'type' : { //P
        'eng' : 'Type',
        'ita' : 'Tipo',
        'fra' : 'Genre',
        'deu' : 'Model',
        'esp' : 'Tipo'
    },
    'price' : { //P
        'eng' : 'Price',
        'ita' : 'Prezzo',
        'fra' : 'Prix',
        'deu' : 'Preis',
        'esp' : 'Precio'
    },
    'brand' : { //P
        'eng' : 'Brand',
        'ita' : 'Marchio',
        'fra' : 'Brand',
        'deu' : 'Brand',
        'esp' : 'Marca'
    },
    'season' : { //P
        'eng' : 'Season',
        'ita' : 'Stagione',
        'fra' : 'Season',
        'deu' : 'Season',
        'esp' : ''
    },
    'showMore' : { //P - toggle
        'eng' : 'Show More',
        'ita' : 'Vedi altro',
        'fra' : 'Montre tous',
        'deu' : 'Mehr zeigen',
        'esp' : ''
    },
    'category' : { //Search box
        'eng' : 'Category',
        'ita' : 'Categorie',
        'fra' : 'Catégories',
        'deu' : 'Kategorien',
        'esp' : ''
    },
    'products' : { //Search box
        'eng' : 'Products',
        'ita' : 'Prodotti',
        'fra' : 'Articles',
        'deu' : 'Artikel',
        'esp' : ''
    },
    'frequentSearches' : { //Search box
        'eng' : 'Most searched',
        'ita' : 'Più ricercati',
        'fra' : 'Plus recherchés',
        'deu' : 'Lieblingsprodukt suchen',
        'esp' : ''
    },

    'isp_add_to_cart_quantity_txt' : { //Q
        'eng' : 'Quantity',
        'ita' : 'Quantità',
        'fra' : 'Quantitè',
        'deu' : 'Anzahl',
        'esp' : ''
    },
    'isp_quick_view_show_more' : { //Q
        'eng' : 'See all details',
        'ita' : 'Vedi dettagli completi',
        'fra' : 'montrer plus',
        'deu' : 'Alles Zeigen',
        'esp' : ''
    },
    'showAllResults' : { //Search box
        'eng' : 'See all matching results',
        'ita' : '',
        'fra' : 'Voir tous les resultats assortis',
        'deu' : 'Alle entsprechende zeigen',
        'esp' : ''
    },
    'showResultsFor' : {
        'eng' : '',
        'ita' : '',
        'fra' : '',
        'deu' : '',
        'esp' : ''
    },
    'sortBy' : {
        'eng' : 'Sort by',
        'ita' : 'Ordina per',
        'fra' : 'trier par  ',
        'deu' : 'Sortieren nach :',
        'esp' : 'Ordena por:'
    },
    'sort_by_relevance' : {
        'eng' : 'Relevance',
        'ita' : 'Rilevanza',
        'fra' : 'pertinence',
        'deu' : 'Beliebste',
        'esp' : 'Relevancia'
    },
    'sort_by_lowest_price' : {
        'eng' : 'Price:low to high',
        'ita' : 'Prezzo: Dal più basso al più alto',
        'fra' : 'Prix: du plus bas au plus haut',
        'deu' : 'Niedrigster Preis',
        'esp' : 'Precio Menor'
    },
    'sort_by_highest_price' : {
        'eng' : 'Price:high to low',
        'ita' : 'Prix: du plus haut au plus bas',
        'fra' : 'Prezzo: dal più alto al più basso',
        'deu' : 'Höchster Preis',
        'esp' : 'Precio Mayor'
    },
    'sort_by_new_prod' : {
        'eng' : 'New arrivals',
        'ita' : 'Arrivi più recenti',
        'fra' : 'Arrivées récentes',
        'deu' : 'Neuheiten',
        'esp' : 'Novedades'
    },
    'sort_by_old_prod' : {
        'eng' : '',
        'ita' : 'Il più vecchio',
        'fra' : '',
        'deu' : '',
        'esp' : 'Mas viejo'
    },
    'ss18' : {
        'eng' : 'Spring Summer 18',
        'ita' : 'Primavera Estate 18',
        'esp' : 'Pimavera Verano 18',
        'fra' : 'Printemps Été 18',
        'deu' : 'Frühling Sommer 18'
    },
    'most_sold' : {
        'esp' : 'Mejor Vendido',
        'eng' : 'Best Seller',
        'fra' : 'Best-seller',
        'deu' : 'Bestseller',
        'ita' : 'Più venduto'
    },
    'sample' : {
        'eng' : '',
        'ita' : '',
        'fra' : '',
        'deu' : '',
        'esp' : ''
    }
};

var ispTranslationQuickViewLinks = [
    {
        'id' : 'addToCart',
        'element' : '.isp_quick_view_add_to_cart_btn'
    },
    {
        'id' : 'viewDetails',
        'element' : '.isp_quick_view_show_more'
    },
    {
        'id' : 'isp_add_to_cart_quantity_txt',
        'element' : '.isp_add_to_cart_quantity_txt'
    }
];

var ispTranslationProductLinks = [

    {
        id : 'view',
        element: '.isp_product_quick_view_text'
    },
    {
        id : 'dream',
        element: '.wk-button-collection.wk-add-product'
    },
    {
        id: 'ss18',
        element: '.seasonTagText'
    },
    {
        id: 'search',
        element: '#isp_main_search_box',
    },
    {
        id: 'type',
        element: '.isp_facet_title_name:contains(Type)'
    },
    {
        id: 'size',
        element: '.isp_facet_title_name:contains(Size)'
    },
    {
        id: 'price',
        element: '.isp_facet_title_name:contains(Price)'
    },
    {
        id: 'brand',
        element: '.isp_facet_title_name:contains(Brand)'
    },
    {
        id: 'season',
        element: '.isp_facet_title_name:contains(Season)'
    },
    {
        id: 'frequentSearches',
        element: '.isp_section_header.isp_section_searches'
    },
    {
        id: 'products',
        element : '.isp_section_header.isp_section_products'
    },
    {
        id: 'category',
        element: '.isp_section_header.isp_section_categories'
    },
    {
        id: 'showAllResults',
        element: '#acp_footer_all'
    },
    {
        id: 'sortBy',
        element: '#search_res_sorting_title'
    }

];


function getActive(){
    var langID = $(".ly-languages-switcher-link.current_lang").attr("id");
    var langs = {
        'ly24248' : 'eng',
        'ly24249' : 'ita',
        'ly25445' : 'fra',
        'ly25446' : 'deu',
        'ly44938' : 'esp'
    };
    return langs[langID];
}

function translateThis (id, target) {
    if(ispTranslations.hasOwnProperty(id)) {
        if(ispTranslations[id].hasOwnProperty(getActive())){
            if(ispTranslations[id][getActive()].length === 0) {
                $(target).text(ispTranslations[id]["eng"]);
            } else {
                $(target).text(ispTranslations[id][getActive()]);
            }
        }
    } else {
        $(target).text(ispTranslations[id]["eng"]);
    }
}

function translateQuickView() {
    for(var c = 0; c < ispTranslationQuickViewLinks.length; c++) {
        var translation = ispTranslationQuickViewLinks[c];
        translateThis(translation.id, translation.element);
    }
}

function translateSearchPage() {
    for(var c = 0; c < ispTranslationProductLinks.length; c++) {
        var translation = ispTranslationProductLinks[c];
        translateThis(translation.id, translation.element);
    }
}

